import { render, staticRenderFns } from "./ApiTableItem.vue?vue&type=template&id=b9356e82&scoped=true&"
import script from "./ApiTableItem.vue?vue&type=script&lang=ts&"
export * from "./ApiTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./ApiTableItem.vue?vue&type=style&index=0&id=b9356e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9356e82",
  null
  
)

export default component.exports